module.exports = __webpack_public_path__ + "img/balloon-right-sm.8c04ee57.svg";